import React from 'react';
import { Box, Container } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../styles/theme';
import logo from '../assets/rounded_logo.svg';
import ListingOnboardingForm from '../components/ListingOnboardingForm';

interface CreateListingPageProps {
  skipAvailability: boolean;
}

const CreateListingPage: React.FC<CreateListingPageProps> = ({ skipAvailability }) => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: '#fafafa',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            bgcolor: 'white',
            borderBottom: '1px solid #e5e7eb',
            position: 'sticky',
            top: 0,
            zIndex: 100,
          }}
        >
          <Container maxWidth="md">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                py: { xs: 1.5, sm: 2 },
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Heyy Property Logo"
                sx={{
                  height: { xs: 40, sm: 50 },
                  width: 'auto',
                }}
              />
            </Box>
          </Container>
        </Box>

        {/* Main Content - Form handles its own container */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            pb: { xs: 4, sm: 6 },
          }}
        >
          <ListingOnboardingForm 
            isVisible={true} 
            skipAvailability={skipAvailability}
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default CreateListingPage;
